import React, { useState } from "react";
import {
  clientOptions,
  geoOptions,
  programOption,
  sbuOptions,
  userOptions,
} from "../../../core/data/js/common-data";
import { ErrorType } from "../../../types/common-type";
import handleClearError from "../../../core/methods/handleClearError";
import MultiSearchableSelect from "./MultiSearchableSelect";
// import { useOrganizations } from "../../../core/customhook/hooks/useOrganizations";
// import { useProjectsByOrgId } from "../../../core/customhook/hooks/projectHooks";
// import { useLocationByProjectId } from "../../../core/customhook/hooks/locationHooks";
// import { usePrograms } from "../../../core/customhook/hooks/programHooks";

export type SearchFormDataType = {
  case_id: string;
  applicant_name: string;
  email: string;
  from_date: string;
  to_date: string;
};

interface Option {
  value: string;
  label: string;
}

export interface FiltersSelectType {
  organization: string[];
  project: string[];
  location: string[];
  program: string[];
  department: string[];
  users: string[];
}

interface FilterProps {
  filterData: any;
  searchFilter?: any;
  setSearchFilter?: React.Dispatch<React.SetStateAction<any>>;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
}

export type SearchPayloadType = FiltersSelectType & SearchFormDataType;

// === initialFilterSelect ===
export const initialFilterSelect = {
  organization: [],
  project: [],
  location: [],
  program: [],
  department: [],
  users: [],
};

const FiltersTrackCase: React.FC<FilterProps> = ({
  filterData,
  setFilterData,
}) => {
  const [errors, setErrors] = useState<ErrorType>({});

  // const {
  //   options: organizationOption,
  //   loading: loadingOrg
  // } = useOrganizations();
  // const {
  //   options: projectOptions,
  //   loading: loadingProject
  // } = useProjectsByOrgId(filterData?.organization)
  // const {
  //   options: locationOptions,
  //   loading: loadingLocation
  // } = useLocationByProjectId(filterData?.project, filterData?.location)
  // const {
  //   options: programOptions,
  //   loading: loadingProgram
  // } = usePrograms(filterData?.project, filterData?.location)

  // validateFilters
  const validateFilters = () => {
    const newErrors: ErrorType = {};
    if (!filterData?.organization?.length) {
      newErrors.organization = "Organization is required";
    }
    if (!filterData?.project?.length) {
      newErrors.project = "Account is required";
    }
    if (!filterData?.location?.length) {
      newErrors.location = "Location is required";
    }
    if (!filterData?.program?.length) {
      newErrors.program = "Program is required";
    }
    if (!filterData?.users?.length) {
      newErrors.users = "User is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // handle select fields
  const handleSelectDataChange = (
    name: string,
    values: string[],
    labels: string[],
  ) => {
    setFilterData((prev: any) => ({
      ...prev,
      [name]: values,
    }));

    handleClearError(setErrors, name);
  };

  // handleSelectSearch
  const handleSelectSearch = () => {
    const isValid = validateFilters();

    if (!isValid) return;
    // console.log("filterData:", filterData);
  };

  return (
    <div className="py-3">
      {/* Select filters */}
      <div className="row mt-4 mt-lg-3 mb-0 gx-2 gy-0 ">
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 ">
          <MultiSearchableSelect
            label="Organization"
            name="organization"
            value={filterData?.organization}
            options={clientOptions}
            onChange={handleSelectDataChange}
            error={errors?.organization}
            // loading={loadingOrg}
            required
          />
        </div>
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 ">
          <MultiSearchableSelect
            label="Account"
            name="project"
            value={filterData?.project}
            options={sbuOptions}
            onChange={handleSelectDataChange}
            // disabled={!filterData?.organization}
            error={errors?.project}
            // loading={loadingProject}
            required
          />
        </div>
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 ">
          <MultiSearchableSelect
            label="Location"
            name="location"
            value={filterData?.location}
            options={geoOptions}
            onChange={handleSelectDataChange}
            // disabled={!filterData?.project}
            error={errors?.location}
            // loading={loadingLocation}
            required
          />
        </div>
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 ">
          <MultiSearchableSelect
            label="Program"
            name="program"
            value={filterData?.program}
            options={programOption}
            onChange={handleSelectDataChange}
            // disabled={!filterData?.location}
            error={errors?.program}
            // loading={loadingProgram}
            required
          />
        </div>
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3 ">
          <MultiSearchableSelect
            label="Department"
            name="department"
            value={filterData?.department}
            options={programOption}
            onChange={handleSelectDataChange}
            // disabled={!filterData?.location}
            error={errors?.department}
            // loading={loadingProgram}
            required
          />
        </div>
        <div className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3">
          <MultiSearchableSelect
            label="Assigned User"
            name="users"
            value={filterData?.users}
            options={userOptions}
            onChange={handleSelectDataChange}
            // disabled={!filterData?.department}
            error={errors?.users}
            required
          />
        </div>
        <div
          className={`col-6 col-sm-4 col-md-3 col-lg-2 mb-3 d-flex gap-2 align-items-end `}
          style={{ height: "70px" }}
        >
          <button
            className="btn btn-primary danger w-50 py-2"
            onClick={() => {
              handleSelectSearch();
            }}
          >
            Search
          </button>
          <button
            className="btn btn-secondary w-50 py-2"
            style={{ minWidth: "max-content" }}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltersTrackCase;
